import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import React from 'react';

import { IOnlinePublicationMessages, IStoryListMessages } from '../../../../types';

export interface INavigationBlockerPopup {
  messages: IStoryListMessages | IOnlinePublicationMessages;
  onConfirmNavigate(): void;
  onCancel(): void;
}

export const NavigationBlockerPopup: React.FC<INavigationBlockerPopup> = (props) => {
  const { messages, onCancel, onConfirmNavigate } = props;
  return (
    <div data-test="navigation-blocker-modal">
      <Dialog open={true} onClose={props.onCancel} aria-labelledby="navigation-blocker-title">
        <DialogTitle id="navigation-blocker-title">{messages.unsavedChanges}</DialogTitle>
        <DialogContent>
          <DialogContentText>{messages.unsavedChangesDescription}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onConfirmNavigate}
            data-test="navigation-blocker-navigate"
            key="navigation-blocker-confirm"
            variant="outlined"
          >
            {messages.yes}
          </Button>
          <Button
            onClick={onCancel}
            variant="contained"
            data-test="navigation-blocker-cancel"
            key="navigation-blocker-cancel"
          >
            {messages.cancel}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
